import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
  Tooltip,
} from '@material-ui/core';
import { T_TitleCell, T_TableRow } from '~/components/TableItem';
import { EAA_Memo, EAA_Input } from '~/components/EditAndAddItem';
import { returnWeekAry, returnMonthAry, returnDatePeriod } from './skill';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CommentIcon from '@material-ui/icons/Comment';
import NoteDialog from '../Actual/NoteDialog';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';



const RenderTableTitle = props => {
  const { label } = props;
  const ary = [
    { name: `${label === 'week' ? '週' : '月'}份` },
    { name: '前次規劃完成數量' },
    { name: '本次規劃完成數量' },
    { name: '實際完成進度'},
    { name: '備註'},
  ];
  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => (
          <T_TitleCell
            key={i}
            text={o.name}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = props => {
  const { data = {}, changeData, disabled, label: L, plan_allnum, AProList } = props;
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [windMechineNum, setWindMechineNum] = useState(0);

  useEffect(() => {
    if (AProList) {
      const { list = [] } = AProList;

      list.forEach((item, i) => {
        const { proc_type = '' } = item;
        if (proc_type == '電業施工許可') {
          const { sub1 = [] } = item;

          if (sub1.length > 0) {
            const { wind_mechine_num = 0 } = sub1[0];
            setWindMechineNum(wind_mechine_num);
          }
        }
      });
    }
  }, [AProList]);
  
  const cellStyle = { fontSize: 14 };
  let plan_num_total = 0;
  let num_total = 0;
  let actural_num_total = 0;
  
  const { plan_start_date, plan_end_date } = data;
  let ary = [];
  let label = '';
  if (plan_start_date && plan_start_date.length > 0 && plan_end_date && plan_end_date.length > 0) {
    switch (L) {
    case 'month':
      ary = returnMonthAry({ start: moment(new Date(plan_start_date)), end: (moment(new Date(plan_end_date))), data });
      label = 'sub3';
      break;
    case 'week':
      ary = returnWeekAry({ start: moment(new Date(plan_start_date)), end: (moment(new Date(plan_end_date))), data });
      label = 'sub5';
      break;
    default:break;
    }
  }

  ary.forEach((o, i) => {
    // 先做mock資料
    // o.actural_num = Math.floor(Math.random() * o.plan_num);
    // o.note = '備註說明....';
    
    plan_num_total += parseInt(o.plan_num) || 0;
    num_total += parseInt(o.num) || 0;
    actural_num_total += parseInt(o.actural_num) || 0;
  });

  const saveSub = dataAry => {
    changeData({ label, data: dataAry });
  };

  const handleClick = (i, o) => {
    setSelectedRow({ index: i, item: o });
    setOpen(true);
  };

  const handleSaveDialog = (i, data) => {
    if (data) {
      ary[i].note = data;
      saveSub(ary);
    }
    handleCloseDialog();
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const checkCount = (i, data) => {
    let num_count = 0;
    ary.forEach((o, i) => {
      num_count += parseInt(o.num) || 0;
    });

    if (plan_allnum < (plan_num_total + num_count)) {
      // console.log(plan_allnum, 'vs', `${plan_num_total} + ${num_count}`);
      // window.alert('您好！提醒您，「本次規劃完成數量」輸入數值合計後 ，已超過「預計完數量」，請再確認修正。');
    }
  }

  return (
    <>
      <TableBody>
        {ary.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>
              {!(L === 'week') && o.plan_yyyymm}
              {L === 'week' && returnDatePeriod(o.plan_yyyymm)}
            </TableCell>
            <TableCell align='center' style={cellStyle}>{o.plan_num}</TableCell>
            <TableCell align='center' style={cellStyle}>
              {/* {o.num} */}
              <EAA_Input displayBorder disabled={disabled} type='number' value={o.num} onChange={data => { ary[i].num = data; saveSub(ary); checkCount(i, data); }} style={{ width: 100 }} />
            </TableCell>
            <TableCell align='center' style={cellStyle}>
              <EAA_Input displayBorder disabled={disabled} type='number' value={o.actural_num} onChange={data => { ary[i].actural_num = data; saveSub(ary); }} style={{ width: 100 }} />
            </TableCell>
            <TableCell>
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={() => handleClick(i, o)}
              >
                <CommentIcon />
              </IconButton>
            </TableCell>
          </T_TableRow>
        ))}

        <T_TableRow key={'total'} backgroundColor='#b2e7eb'>
          <TableCell align='center' style={cellStyle}> 總計 </TableCell>
          <TableCell align='center' style={cellStyle}>{plan_num_total}</TableCell>
          <TableCell align='center' style={cellStyle}>{num_total}</TableCell>
          <TableCell align='center' style={cellStyle}>{actural_num_total}</TableCell>
          <TableCell></TableCell>
        </T_TableRow>

        <T_TableRow backgroundColor='white'>
          <TableCell colSpan={5} style={{ paddingRight: 35, textAlign: 'right' }}>
            {'完成數量百分比: ' + ((actural_num_total / plan_num_total) * 100).toFixed(2) + ' %'}
          </TableCell>
        </T_TableRow>
        {
          plan_num_total > plan_allnum &&
            <T_TableRow backgroundColor='white'>
              <TableCell colSpan={5} style={{ paddingRight: 35, textAlign: 'right' }}>
                <Alert severity='error' style={{ backgroundColor: '#f5c3bf' }}>
                  您好！提醒您，「本次規劃完成數量」輸入數值合計後 ，已超過「預計完數量」，請再確認修正。
                </Alert>
              </TableCell>
            </T_TableRow>
        }
      </TableBody>
      <NoteDialog
        isOpen={open}
        target={selectedRow}
        onClose={handleCloseDialog}
        onSave={handleSaveDialog}
      />
    </>
  );
};

const RenderTable = props => (
  <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
    <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
      <RenderTableTitle {...props} />
      {/* {haveData && this.renderTableBody()} */}
      <RenderTableBody {...props} />
    </Table>
  </TableContainer>
);

const App = props => {
  const { data = {}, disabled, errorAry, label } = props;
  const [text, setText] = useState('');

  let plan_desc = '';
  let plan_date = '';

  switch (label) {
  case 'month':
    plan_desc = ((data.sub3 || [])[0] || {}).plan_desc || '';
    plan_date = ((data.sub3 || [])[0] || {}).plan_date || '';
    break;
  case 'week':
    plan_desc = ((data.sub5 || [])[0] || {}).plan_desc || '';
    plan_date = ((data.sub5 || [])[0] || {}).plan_date || '';
    break;
  default:break;
  }
  const returnText = (t = '') => {
    try {
      return t.length > 0 ? t : '(無)';
    } catch {
      return '(無)';
    }
  };

  return [
    <div key='Planning_Title' style={{ fontWeight: 700, fontSize: 20, textAlign: 'start', marginTop: 24 }}>{`每${label === 'week' ? '週' : '月'}規劃進度`}</div>,
    <RenderTable key='Planning_RenderTable' {...props} />,
    <div key='Planning_Bar' style={{ display: 'flex', flexDirection: 'column', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>規劃進度更新說明</div>
        <div style={{ flex: 1, marginRight: 8 }}>{returnText(plan_desc)}</div>
        {/*
          <EAA_Memo id={`Page_ProjectProgress_memo_${label}`} disabled={disabled} displayBorder marginRight={8} hint='必填' value={text} onChange={data => setText(data)} />
        */}
        <EAA_Memo id={`Page_ProjectProgress_memo_${label}`} displayBorder marginRight={8} hint='必填' value={text} onChange={data => setText(data)} />
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>(主管)送出日期</div>
        <div style={{ flex: 1, marginRight: 8 }}>{returnText(plan_date)}</div>
        {label === 'month' && <div style={{ flex: 1, marginRight: 8, color: 'red' }}>{errorAry[11] && '請輸入'}</div>}
        {label === 'week' && <div style={{ flex: 1, marginRight: 8, color: 'red' }}>{errorAry[12] && '請輸入'}</div>}
      </div>
    </div>,
  ];
};

export default App;
